export default __webpack_public_path__ + "static/media/declaration-img.deda6eff.png";